
// This file is auto-generated. Do not edit directly.
// Last updated: 2026-01-28T20:41:17.976Z

export const siteContent = {
  "members": [
    {
      "": "",
      "Name": "Shawn Shih",
      "Position": "Chapter Co-President",
      "Year": "2027",
      "Major": "Global Health",
      "ImageUrl": "https://res.cloudinary.com/dgivojiqh/image/upload/v1756958040/PBPAIPk_-_Imgur_zlbbiw.webp",
      "LinkedIn": "https://www.linkedin.com/in/rachanakadikar/",
      "Type": "eboard",
      "Bio": "",
      "Minor": "Business"
    },
    {
      "": "",
      "Name": "Kidist Nega",
      "Position": "Chapter Co-President",
      "Year": "2026",
      "Major": "Business Administration",
      "ImageUrl": "https://imgur.com/JGDw099.jpeg",
      "LinkedIn": "https://www.linkedin.com/in/skyler-korkowski/",
      "Type": "eboard"
    },
    {
      "": "",
      "Name": "Emmie Chun",
      "Position": "VP of Communications",
      "Year": "2028",
      "Major": "Business Administration",
      "ImageUrl": "https://i.imgur.com/JDnMjMZ.jpeg",
      "LinkedIn": "https://www.linkedin.com/in/emmiechun/",
      "Type": "eboard"
    },
    {
      "": "",
      "Name": "Chloe Wong",
      "Position": "VP of Social Programming",
      "Year": "2027",
      "Major": "Business Administration",
      "ImageUrl": "https://i.imgur.com/s00ROWu.jpeg",
      "LinkedIn": "https://www.linkedin.com/in/chloe-wong-0000822a9/",
      "Type": "eboard"
    },
    {
      "": "",
      "Name": "Meghan Webster",
      "Position": "VP of Operations",
      "Year": "2027",
      "Major": "Accounting",
      "ImageUrl": "https://i.imgur.com/LCfM732.jpeg",
      "LinkedIn": "https://www.linkedin.com/in/meghan-webster",
      "Type": "eboard"
    },
    {
      "": "",
      "Name": "Erica Wang",
      "Position": "VP of Expansion",
      "Year": "2027",
      "Major": "Global Health",
      "ImageUrl": "https://i.imgur.com/OyxWERA.jpeg",
      "LinkedIn": "https://www.linkedin.com/in/ashleyhuang819/",
      "Type": "eboard"
    },
    {
      "": "",
      "Name": "Sally Hong",
      "Position": "VP of Social Programming",
      "Year": "2027",
      "Major": "Industrial Systems Engineering",
      "ImageUrl": "https://i.imgur.com/8Y3yDw8.jpeg",
      "LinkedIn": "https://www.linkedin.com/in/harrymoon/",
      "Type": "eboard"
    },
    {
      "": "",
      "Name": "Peggy Wu",
      "Position": "VP of Activism",
      "Year": "2028",
      "Major": "Public Policy & International Relations",
      "ImageUrl": "https://i.imgur.com/7NqNuwi.jpeg",
      "LinkedIn": "https://www.linkedin.com/in/shawn-shih-75642b297/",
      "Type": "eboard"
    },
    {
      "": "",
      "Name": "Andrew Hsia",
      "Position": "VP of Professional Programming",
      "Year": "2026",
      "Major": "Business Administration & Real Estate",
      "ImageUrl": "https://i.imgur.com/5gl2tku.jpeg",
      "LinkedIn": "https://www.linkedin.com/in/leo-rosales-woo/",
      "Type": "eboard"
    },
    {
      "": "",
      "Name": "Neelie Lim",
      "Position": "VP of Leadership Development",
      "Year": "2026",
      "Major": "Business Administration",
      "ImageUrl": "https://i.imgur.com/zJVpsER.jpeg",
      "LinkedIn": "https://www.linkedin.com/in/kidistnega2003/",
      "Type": "eboard"
    },
    {
      "": "",
      "Name": "Vionna Huang",
      "Position": "VP of DEI",
      "Year": "2026",
      "Major": "Cognitive Science",
      "ImageUrl": "https://i.imgur.com/FgCBbnh.jpeg",
      "LinkedIn": "https://www.linkedin.com/in/zainshafikhan/",
      "Type": "eboard"
    },
    {
      "": "",
      "Name": "Lucas Oddi",
      "Position": "Sergeant at Arms",
      "Year": "2027",
      "Major": "Behavioral Economics & Pscyhology",
      "ImageUrl": "https://i.imgur.com/AdUULS9.jpeg",
      "LinkedIn": "https://www.linkedin.com/in/katelyn-saiki/",
      "Type": "eboard"
    },
    {
      "": "",
      "Name": "Will Tran",
      "Position": "VP of Communications",
      "Year": "2026",
      "Major": "Accounting"
    }
  ],
  "achievements": [
    {
      "": "",
      "Company": "Microsoft",
      "ImageUrl": "https://nforceit.com.au/wp-content/uploads/2023/09/nforceit-partner-microsoft-logo.png"
    },
    {
      "": "",
      "Company": "Amazon",
      "ImageUrl": "https://1000logos.net/wp-content/uploads/2016/10/Amazon-Logo.png"
    },
    {
      "": "",
      "Company": "Apple",
      "ImageUrl": "https://1000logos.net/wp-content/uploads/2017/02/Apple-Logosu.png"
    },
    {
      "": "",
      "Company": "Google",
      "ImageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/800px-Google_2015_logo.svg.png"
    },
    {
      "": "",
      "Company": "pwc",
      "ImageUrl": "https://logos-world.net/wp-content/uploads/2022/01/PwC-PricewaterhouseCoopers-Symbol.png"
    },
    {
      "": "",
      "Company": "NBA",
      "ImageUrl": "https://1000logos.net/wp-content/uploads/2017/04/Logo-NBA.png"
    },
    {
      "": "",
      "Company": "NASA",
      "ImageUrl": "https://gpm.nasa.gov/sites/default/files/document_files/NASA-Logo-Large.png"
    },
    {
      "": "",
      "Company": "Los Angeles Times",
      "ImageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/Los_Angeles_Times_logo.svg/1280px-Los_Angeles_Times_logo.svg.png"
    },
    {
      "": "",
      "Company": "Meta",
      "ImageUrl": "https://upload.wikimedia.org/wikipedia/commons/7/7b/Meta_Platforms_Inc._logo.svg"
    },
    {
      "": "",
      "Company": "Dell",
      "ImageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Dell_Logo.svg/1024px-Dell_Logo.svg.png"
    },
    {
      "": "",
      "Company": "Paramount",
      "ImageUrl": "https://upload.wikimedia.org/wikipedia/commons/8/89/Paramount_Pictures_2022_%28Blue%29.svg"
    },
    {
      "": "",
      "Company": "Nike",
      "ImageUrl": "https://logos-world.net/wp-content/uploads/2020/04/Nike-Logo.png"
    },
    {
      "": "",
      "Company": "Samsung",
      "ImageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Samsung_Logo.svg/2560px-Samsung_Logo.svg.png"
    },
    {
      "": "",
      "Company": "Intel",
      "ImageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/85/Intel_logo_2023.svg/2560px-Intel_logo_2023.svg.png"
    },
    {
      "": "",
      "Company": "SpaceX",
      "ImageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/SpaceX_logo_black.svg/2560px-SpaceX_logo_black.svg.png"
    },
    {
      "": "",
      "Company": "LinkedIn",
      "ImageUrl": "https://download.logo.wine/logo/LinkedIn/LinkedIn-Logo.wine.png"
    },
    {
      "": "",
      "Company": "Tesla",
      "ImageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Tesla_Motors.svg/372px-Tesla_Motors.svg.png"
    },
    {
      "": "",
      "Company": "Warner Brothers",
      "ImageUrl": "https://upload.wikimedia.org/wikipedia/commons/6/64/Warner_Bros_logo.svg"
    },
    {
      "": "",
      "Company": "NBC",
      "ImageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/NBC_Peacock_1986.svg/1200px-NBC_Peacock_1986.svg.png"
    },
    {
      "": "",
      "Company": "BlackRock",
      "ImageUrl": "https://1000logos.net/wp-content/uploads/2021/09/BlackRock-logo.png"
    },
    {
      "": "",
      "Company": "Sony",
      "ImageUrl": "https://upload.wikimedia.org/wikipedia/commons/c/ca/Sony_logo.svg"
    },
    {
      "": "",
      "Company": "Deloitte",
      "ImageUrl": "https://familynurture.org/wp-content/uploads/2018/06/Deloitte-Logo-e1505158716925.png"
    },
    {
      "": "",
      "Company": "BMW",
      "ImageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/BMW.svg/2048px-BMW.svg.png"
    },
    {
      "": "",
      "Company": "USC",
      "ImageUrl": "https://identity.usc.edu/wp-content/uploads/2022/09/PrimaryMonogram_0921.png"
    },
    {
      "": "",
      "Company": "United Nations",
      "ImageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ee/UN_emblem_blue.svg/2405px-UN_emblem_blue.svg.png"
    },
    {
      "": "",
      "Company": "WWF",
      "ImageUrl": "https://upload.wikimedia.org/wikipedia/en/thumb/2/24/WWF_logo.svg/1200px-WWF_logo.svg.png"
    },
    {
      "": "",
      "Company": "EA",
      "ImageUrl": "https://upload.wikimedia.org/wikipedia/commons/e/e5/Electronic_Arts_Logo_2020.png"
    },
    {
      "": "",
      "Company": "Youtube",
      "ImageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Logo_of_YouTube_%282015-2017%29.svg/2560px-Logo_of_YouTube_%282015-2017%29.svg.png"
    }
  ],
  "features": [
    {
      "": "",
      "Name": "Chan"
    }
  ],
  "generalContent": [
    {
      "": "",
      "Name": "Mia"
    }
  ]
};
